import { render } from "./UserMenu.vue?vue&type=template&id=e3e72ae0&ts=true&xmlns%3Ag=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__